// extracted by mini-css-extract-plugin
module.exports = {"table":"src-components-Table-Table_table--1DoSj9nr"};